import { IUserSession } from '../../../helpers/user-session';
import { LoggerService } from '../../common/common.module';
import { DeviceCreateEditController } from './devices-create-edit.directive.controller';
import { DEVICE_SERVICE_NAME, DeviceService } from '../../../services/device'

//#region Asset Imports

import './devices-create-edit.scss'
import * as TEMPLATE from './devices-create-edit.tpl.html'

//#endregion

// Setup

export class DevicesCreateEditDirective
    implements ng.IDirective
{
    restrict = 'E'

    controller = ['$scope', '$q', '$timeout', 'logger', 'userSession', DEVICE_SERVICE_NAME, (
        $scope: any,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        userSession: IUserSession,
        deviceService: DeviceService
    ) => new DeviceCreateEditController(
        $scope,
        $q,
        $timeout,
        logger,
        userSession,
        DeviceService.REFERENCE_TYPE,
        DeviceService.SIMAX_MODULE_NAME,
        deviceService
    )]

    template = TEMPLATE
}